  import React, { useState, useEffect } from "react";
  import {
    AppBar,
    Toolbar,
    Button,
    Typography,
    Container,
    Grid,
    Card,
    CardContent,
    TextField,
    MenuItem,
    Box,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
  } from "@mui/material";
  import { Link } from "react-router-dom";
  import MenuIcon from "@mui/icons-material/Menu";
  import bgImage from "../assets/bgimage.jpeg"; // Replace with your hero image
  import logo from "../assets/th.jpg"; // Replace with your logo
  import api from "../services/api"; // API call setup

  // Fetching dynamic data for grades and diseases
  const fetchGrades = async () => {
    try {
      const response = await api.get("https://dealsphere.nutrifytoday.com/api/label_claims/grades");
      // Ensure the response is always an array
      return Array.isArray(response.data) ? response.data : [];
    } catch (err) {
      console.error("Failed to fetch grades", err);
      return [];
    }
  };

  const fetchDiseases = async () => {
    try {
      const response = await api.get("https://dealsphere.nutrifytoday.com/api/label_claims/diseases");
      return Array.isArray(response.data) ? response.data : [];
    } catch (err) {
      console.error("Failed to fetch diseases", err);
      return [];
    }
  };

  function LabelClaimsPage() {
    const [labelClaims, setLabelClaims] = useState([]);
    const [grades, setGrades] = useState([]);
    const [countries] = useState(["India"]); // Static country as per the request
    const [diseases, setDiseases] = useState([]);
    const [filters, setFilters] = useState({
      grade: "",
      country: "India", // Set to India as requested
      disease: "",
    });
    const [drawerOpen, setDrawerOpen] = useState(false);

    // Fetch label claims with filters
    useEffect(() => {
      const fetchLabelClaims = async () => {
    try {
      const params = {};
      if (filters.grade) params.grade = filters.grade;
      if (filters.country) params.country = filters.country;
      if (filters.disease) params.disease = filters.disease;

      console.log("Fetching Label Claims with filters:", params);

      const response = await api.get("https://dealsphere.nutrifytoday.com/api/label_claims/", { params });

      console.log("Full API Response:", response); // Log the full response

      // If the actual data is inside another object, adjust accordingly
      const claims = response.data?.claims || response.data || [];  
      console.log("Fetched Label Claims:", claims);
      setLabelClaims(claims);
    } catch (err) {
      console.error("Failed to fetch label claims", err);
    }
  };


      fetchLabelClaims();
    }, [filters]);

    // Fetch grades and diseases dynamically on component mount
    useEffect(() => {
      const loadGradesAndDiseases = async () => {
        console.log("Fetching grades and diseases...");
        const fetchedGrades = await fetchGrades();
        console.log("Fetched Grades:", fetchedGrades); // Log the grades
        setGrades(fetchedGrades);

        const fetchedDiseases = await fetchDiseases();
        console.log("Fetched Diseases:", fetchedDiseases); // Log the diseases
        setDiseases(fetchedDiseases);
      };

      loadGradesAndDiseases();
    }, []);

    // Handle filter changes
    const handleFilterChange = (event) => {
      const { name, value } = event.target;
      setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
    };

    // Toggle drawer (hamburger menu)
    const toggleDrawer = (open) => {
      setDrawerOpen(open);
    };

    return (
      <div style={{ fontFamily: "Inter, sans-serif" }}>
        {/* Navigation Bar */}
        <AppBar position="sticky" sx={{ backgroundColor: "rgb(4, 107, 210)", boxShadow: "none" }}>
          <Toolbar sx={{ display: "flex", justifyContent: "space-between", padding: "0 20px" }}>
            <img
              src={logo}
              alt="Logo"
              style={{
                height: "50px",
                borderRadius: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                transition: "transform 0.3s ease-in-out",
                display: "inline-block",
                margin: "5px",
              }}
              onMouseOver={(e) => (e.target.style.transform = "scale(1.1)")}
              onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
            />
            {/* Mobile Hamburger Menu */}
            <IconButton sx={{ display: { xs: "block", md: "none" } }} color="inherit" onClick={() => toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>

            {/* Desktop Menu */}
            <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
              <Button color="inherit" component={Link} to="/" sx={{ fontWeight: "bold" }}>Home</Button>
              <Button color="inherit" component={Link} to="/LabelDetails" sx={{ fontWeight: "bold" }}>Label Claims</Button>
              <Button color="inherit" component={Link} to="/about" sx={{ fontWeight: "bold" }}>About</Button>
              <Button color="inherit" component={Link} to="/contact" sx={{ fontWeight: "bold" }}>Contact</Button>
              <Button color="inherit" component={Link} to="/login" sx={{ fontWeight: "bold" }}>Login</Button>
              <Button
                variant="contained"
                component={Link}
                to="/signup"
                sx={{
                  backgroundColor: "rgb(245, 144, 59)",
                  "&:hover": { backgroundColor: "rgb(67, 20, 29)" },
                }}
              >
                Register
              </Button>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Mobile Drawer */}
        <Drawer anchor="right" open={drawerOpen} onClose={() => toggleDrawer(false)}>
          <List sx={{ width: 250 }}>
            <ListItem button component={Link} to="/" onClick={() => toggleDrawer(false)}>
              <ListItemText primary="Home" />
            </ListItem>
            <ListItem button component={Link} to="/LabelDetails" onClick={() => toggleDrawer(false)}>
              <ListItemText primary="Label Claims" />
            </ListItem>
            <ListItem button component={Link} to="/about" onClick={() => toggleDrawer(false)}>
              <ListItemText primary="About" />
            </ListItem>
            <ListItem button component={Link} to="/contact" onClick={() => toggleDrawer(false)}>
              <ListItemText primary="Contact" />
            </ListItem>
            <ListItem button component={Link} to="/login" onClick={() => toggleDrawer(false)}>
              <ListItemText primary="Login" />
            </ListItem>
            <ListItem button component={Link} to="/signup" onClick={() => toggleDrawer(false)}>
              <ListItemText primary="Register" />
            </ListItem>
          </List>
        </Drawer>

        {/* Hero Section */}
        <Box
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "30vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            color: "rgba(80, 25, 25, 0.88)",
            padding: "0 20px",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: "700",
              fontFamily: "Mulish, sans-serif",
              textShadow: "2px 2px 5px rgba(0,0,0,0.5)",
            }}
          >
            Explore Label Claims
          </Typography>
        </Box>

        {/* Filters */}
        <Container sx={{ marginTop: "30px", marginBottom: "20px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField select label="Grade" fullWidth name="grade" value={filters.grade} onChange={handleFilterChange}>
                <MenuItem value="">All Grades</MenuItem>
                {grades.length > 0 ? (
                  grades.map((grade, index) => (
                    <MenuItem key={index} value={grade}>
                      {grade}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No Grades Available</MenuItem>
                )}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField select label="Country" fullWidth name="country" value={filters.country} onChange={handleFilterChange} disabled>
                <MenuItem value="India">India</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField select label="Disease" fullWidth name="disease" value={filters.disease} onChange={handleFilterChange}>
                <MenuItem value="">All Diseases</MenuItem>
                {diseases.length > 0 ? (
                  diseases.map((disease) => (
                    <MenuItem key={disease} value={disease}>
                      {disease}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No Diseases Available</MenuItem>
                )}
              </TextField>
            </Grid>
          </Grid>
        </Container>

        {/* Label Claims Grid */}
        <Container>
          <Grid container spacing={4}>
            {labelClaims.length > 0 ? (
              labelClaims.map((claim) => (
                <Grid item xs={12} sm={6} md={4} key={claim.id}>
                  <Card
                    sx={{
                      borderRadius: "10px",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                      transition: "transform 0.3s",
                      "&:hover": { transform: "scale(1.05)" },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h6"
                        sx={{
                          color: "rgb(51, 65, 85)",
                          fontWeight: "bold",
                          fontFamily: "Mulish, sans-serif",
                        }}
                      >
                        {claim.label_claim}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "rgb(118, 123, 146)" }}>
                        {claim.description}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "rgb(51, 65, 85)", fontWeight: "bold" }}>
                        Grade: {claim.grade}
                      </Typography>
                      <Link to="/login">
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{
                            marginTop: "10px",
                            width: "100%",
                            backgroundColor: "rgb(245, 144, 59)",
                            "&:hover": { backgroundColor: "rgb(67, 20, 29)" },
                          }}
                        >
                          View More
                        </Button>
                      </Link>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            ) : (
              <Typography variant="h6">No Label Claims Found</Typography>
            )}
          </Grid>
        </Container>

        {/* Footer */}
        <Box sx={{ backgroundColor: "rgb(51, 65, 85)", color: "white", padding: "20px 0", textAlign: "center", marginTop: "40px" }}>
          <Typography variant="body2">© 2025 DealSphere. All rights reserved.</Typography>
          <Box sx={{ display: "flex", justifyContent: "center", marginTop: "10px", gap: "15px" }}>
            <Button sx={{ color: "white", textTransform: "none" }} component={Link} to="/terms">
              Terms
            </Button>
            <Button sx={{ color: "white", textTransform: "none" }} component={Link} to="/privacy">
              Privacy
            </Button>
            <Button sx={{ color: "white", textTransform: "none" }} component={Link} to="/contact">
              Contact
            </Button>
          </Box>
        </Box>
      </div>
    );
  }

  export default LabelClaimsPage;
